
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/console/company/login",
      function () {
        return require("private-next-pages/console/company/login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/console/company/login"])
      });
    }
  